import { useQuery } from "react-query";
import { locationsApi, type Location } from "@/lib/api/locations";

export const LOCATIONS_QUERY_KEY = ["locations"] as const;

export function useLocations(includeInactive = true, options?: { enabled?: boolean }) {
  return useQuery<Location[]>(
    [...LOCATIONS_QUERY_KEY, includeInactive],
    () => locationsApi.getAll(includeInactive),
    { staleTime: 60 * 60 * 1000, enabled: options?.enabled ?? true }
  );
}
